import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { page, setData, setDataAdmin, setResidueImg } from "../../storeredux"
import { Page, readData, readDataAdmin, readDataResidue } from "../utils/datautils"
import Header from "../utils/headerinfo"
import { Build, DeveloperBoard } from "@mui/icons-material"
import About from "./About"
import Activity from "./Activity"
import Staff from "./Staff"
import Alumni from "./Alumni"
import Achievement from "./Achievement"
import Footer from "../utils/footer"
import { Alert, AlertTitle, Box, Snackbar } from "@mui/material"
import LoginContainer from "../others-component/LoginContainer"
import ActivityBuilder from "./ActivityBuilder"
import Developer from "./Developer"
import Dev from "./DevProf"
import TitleAnimate from "../utils/titleanimate"
import { Panel } from "../utils/other"

export default function Main() {
    const dispatch = useDispatch()
    const [error,setError] = useState()
    const pages = useSelector(page)

    useEffect(async() => {
        dispatch(setData(await readData()))
        dispatch(setDataAdmin(await readDataAdmin()))
        dispatch(setResidueImg(await readDataResidue()))
    },[])

    return(
        <>
            <Panel value={Page.HOME} validate={pages}>
                <Header path1={Page.ADMIN} path2={Page.TEAM} icon1={<Build/>} icon2={<DeveloperBoard/>}
                    desc1='Data Center' desc2='Our Team'/>
                <TitleAnimate/>
                <Box sx={{marginBottom:'60px',padding:'5%'}}>
                    <About/>
                    <Activity setError={setError}/>
                    <Staff setError={setError}/>
                    <Alumni setError={setError}/>
                    <Achievement setError={setError}/>
                </Box>
                <Footer/>
                <Snackbar open={Boolean(error)} anchorOrigin={{vertical:'top', horizontal:'center'}} autoHideDuration={3000} onClose={a => setError(null)}>
                    <Alert severity='error' onClose={a => setError(null)}>
                        <AlertTitle>Error</AlertTitle>
                        {error}
                    </Alert>
                </Snackbar>
            </Panel>
            <Panel value={Page.ADMIN} validate={pages}>
                <LoginContainer/>
            </Panel>
            <Panel value={Page.DEV} validate={pages}>
                <LoginContainer/>
            </Panel>
            <Panel value={Page.ADMINC} validate={pages}>
                <ActivityBuilder/>
            </Panel>
            <Panel value={Page.DEVC} validate={pages}>
                <Developer/>
            </Panel>
            <Panel value={Page.TEAM} validate={pages}>
                <Dev/>
            </Panel>
        </>
    )
}